import { useCheckAccessQuery } from '@/app/common/api/accessLevelApi';
import type { CheckAccessResponse } from '@/app/common/api/types/accessLevelApiTypes';
import type { ApiQueryError } from '@/app/common/utils/apiErrorUtils';
import useDomain from '@/hooks/useDomain';

export type ToolName = string | null;

export type ToolAccessData = CheckAccessResponse;

export interface ToolAccessResult {
  accessData: ToolAccessData | undefined;
  isLoading: boolean;
  isError: boolean;
  error: ApiQueryError;
  haveAccess: boolean;
  refetch: () => void;
  isFetching: boolean;
}

export const useToolAccess = (
  tool_name: ToolName,
  options?: { skip?: boolean }
): ToolAccessResult => {
  const { domain_slug } = useDomain();

  const {
    data: accessData,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useCheckAccessQuery(
    { domain_slug, tool_name },
    { skip: Boolean(options?.skip) }
  );

  return {
    accessData,
    isLoading,
    isError,
    error,
    haveAccess: Boolean(accessData?.data?.have_access),
    refetch,
    isFetching
  };
};

export default useToolAccess;
